// shows the group's current bill amount.
export class CurrentBillAmount extends HTMLElement {

  constructor() {
    super();
  }

  async connectedCallback() {
    const bill_amount = this.getAttribute('bill_amount')

    this.innerHTML = `
      <style>
      </style>

      <div class="light-colored-container">
        <h4>Current bill:</h4>
        <h3 id="current_bill_amount">$${bill_amount * 0.01}</h3>
      </div> 
    `
  }
}
customElements.define('current-bill-amount', CurrentBillAmount)